( function() {
  var timerClass = "j-timer",
      lowTimeClass = "time-remaining--danger",
      lowTimeLimit = 30,
      timeEl,
      form,
      timer,
      secondsLeft;

  function writeTime() {
    var min, sec, paddedSec;

    if ( secondsLeft < 0 ) {
      secondsLeft = 0;
    }

    min = Math.floor( secondsLeft / 60 );
    sec = secondsLeft % 60;
    paddedSec = ( sec < 10 ) ? "0" + sec : sec;

    timeEl.innerHTML = min + ":" + paddedSec;

    if ( secondsLeft === lowTimeLimit ) {
      timeEl.className += " " + lowTimeClass;
    }
  }

  function doTimer() {
    if ( secondsLeft < 1 ) {
      writeTime();
      clearInterval( timer );
      if ( form ) {
        form.submit();
      }
    } else {
      secondsLeft--;
      writeTime();
    }
  }

  function init() {
    timeEl = document.querySelector( "." + timerClass );

    if ( timeEl !== null ) {
      var secs = timeEl.getAttribute( "data-seconds" ),
          formId = timeEl.getAttribute( "data-form" );

      if ( formId ) {
        form = document.getElementById( formId );
      }

      if ( secs ) {
        secondsLeft = parseInt( secs );
        writeTime();
        timer = setInterval( doTimer, 1000 );
      }
    }
  }

  init();

})();
